import { UNKNOWN_ERROR_MESSAGE } from "../../messaging/messages";
import { addMessage, unWait } from "../uiActions";
import { logOutUser } from "../globalActions";
import { schemaRequestCompleted } from "../schemaActions";


export default function standardResponseHandler({
																									response,
																									dispatch,
																									errorHandler,
																									successHandler,
																									options: {
																										navigate = null,
																										successMessage = null,
																										successRedirectUrl = null,
																										id = null,
																										castToJson = true,
																										property = null,
																									},
																								}) {
	dispatch(unWait());
	if (id) {
		dispatch(schemaRequestCompleted(id));
	}
	if (response.ok) {
		handleOkResponse({
			response,
			dispatch,
			navigate,
			errorHandler,
			successHandler,
			successMessage,
			successRedirectUrl,
			id,
			castToJson,
			property,
		});
	} else {
		handleErrorResponse({ response, dispatch, navigate, errorHandler, id });
	}
}

function handleErrorResponse({
															 response,
															 dispatch,
															 navigate,
															 errorHandler,
															 id,
														 }) {
	if (response.status === 401) {
		dispatch(logOutUser(navigate));
	} else {
		handleNonForbiddenErrorResponse({ response, dispatch, errorHandler, id });
	}
}

function handleNonForbiddenErrorResponse({
																					 response,
																					 dispatch,
																					 errorHandler,
																					 id,
																				 }) {
	response
		.json()
		.then((json) => errorHandler(json, dispatch, id))
		.catch((error) =>
			handleJsonCastingError({ error, dispatch, errorHandler, id })
		);
}

function handleOkResponse({
														response,
														dispatch,
														navigate,
														errorHandler,
														successHandler,
														successMessage,
														successRedirectUrl,
														id,
														castToJson,
														property,
													}) {
	if (castToJson) {
		response
			.json()
			.then((json) => {
				handleSuccessScenarios({
					json,
					dispatch,
					navigate,
					successHandler,
					successMessage,
					successRedirectUrl,
					id,
					property,
				});
			})
			.catch((error) =>
				handleJsonCastingError({ error, dispatch, errorHandler })
			);
	} else {
		handleSuccessScenarios({
			dispatch,
			navigate,
			successHandler,
			successMessage,
			successRedirectUrl,
			id,
			property,
		});
	}
}

function handleJsonCastingError({ error, dispatch, errorHandler, id }) {
	console.error(error);
	errorHandler(UNKNOWN_ERROR_MESSAGE, dispatch, id);
}

function handleSuccessScenarios({
																	json,
																	dispatch,
																	navigate,
																	successHandler,
																	successMessage,
																	successRedirectUrl,
																	id,
																	property,
																}) {
	successHandler(json, dispatch, id, property);
	if (successRedirectUrl) {
		if (!navigate) {
			throw new Error(
				"You must provide the navigation function if you provide a successRedirectUrl"
			);
		}
		navigate(successRedirectUrl);
	}
	if (successMessage) {
		dispatch(addMessage(successMessage));
	}
}
